/**
 * Recommendations (owner rules, 2026-10-24) — cart drawer upsell (sections/cart-upsell.liquid) and
 * "Vous aimerez aussi" under the product page (sections/related-products.liquid).
 *
 * Pool (owner, 26 Oct 2026): the sub-collections of the audience (SUBS below), each fetched after the page and kept
 * 10 min in sessionStorage: <locale root>collections/<sub>?sort_by=best-selling&filter.v.availability=1
 * &section_id=bombas-reco-pool (sections/bombas-reco-pool.liquid: its 30 best-selling products whose stock is tracked
 * and in stock; each item carries its creation date). Same requests as before, no extra one.
 * Audience of a product: product metafield custom.audience, else assets/bombas-audience.js (computed from the
 * French handle / type), else the custom.audience of its collections.
 *
 * Choice (owner, 26 Oct 2026: vary it, not only new arrivals):
 * 1. same audience only: homme → homme + mixte · femme → femme + mixte · mixte → mixte + homme + femme ·
 *    fille → fille + enfant (unisex kids) · garçon → garçon + enfant · enfant → all kids · bébé → bébé + enfant.
 *    Kids never get adult products and adults never get kids products.
 * 2. never the current product nor a product already in the cart.
 * 3. three groups, about a third each: RELATED (same sub-collection / category as the source item), BEST SELLERS
 *    (top of the other sub-collections), DISCOVERY (older / less-seen products + a couple of new arrivals).
 * 4. inside each group: the customer's size first when possible (shoes and kids; same size system only — another
 *    system or one size isn't pushed down), good stock first, then random. Max 3 per sub-collection.
 * 5. shuffled on every call (each cart-drawer open / page load). Up to 12 cards (horizontal scroll; 8 in the desktop
 *    cart panel); fewer than 4: filled from whatever is left in the audience.
 * 6. cart drawer only (owner, 30 Oct 2026): the first 2 cards come from the added item's sub-collection (customer's
 *    size first, then -100 DH products, then good stock) and stay first; the other cards follow rules 3–5.
 */
(function () {
  'use strict';
  if (window.BBReco) return;

  var TTL = 10 * 60 * 1000;
  var CODES = { homme: 'h', femme: 'f', mixte: 'm', fille: 'F', garcon: 'G', enfant: 'E', bebe: 'B', enfants: 'E' };
  var COMPAT = { h: 'hm', f: 'fm', m: 'mhf', F: 'FE', G: 'GE', E: 'EFGB', B: 'BE' };
  var MAX = 12;
  var MIN = 4;
  var PER_SUB = 3; // max cards from one sub-collection
  // Sub-collections per audience (owner, 25 Oct 2026).
  var SUBS = {
    h: ['sneakers-pour-homme', 'pantoufles-pour-homme', 'pyjama-pour-homme', 'peignoir-pour-homme', 'sandales-homme'],
    f: ['baskets-sneakers-pour-femme', 'chaussures-femme', 'bottes-bottines-pour-femme', 'pantoufles-pour-femme', 'pyjamas-pour-femmes', 'sandales-femme'],
    k: ['baskets-sneakers-enfants', 'bottes-bottines-pour-enfants', 'mocassins-enfants', 'pantoufles-pour-enfants', 'pyjamas-pour-enfants', 'sandales-pour-enfants']
  };

  function subsFor(aud) {
    if (aud === 'h') return SUBS.h;
    if (aud === 'f') return SUBS.f;
    if (aud === 'm') return SUBS.h.concat(SUBS.f);
    return 'FGEB'.indexOf(aud) > -1 && aud ? SUBS.k : [];
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = s.onerror = function () {
        resolve();
      };
      document.head.appendChild(s);
    });
  }

  var audMap = null;
  function audienceMap(src) {
    if (audMap) return audMap;
    audMap = (window.bbAudience ? Promise.resolve() : loadScript(src)).then(function () {
      var m = { aud: {}, cat: {} };
      var a = window.bbAudience || {};
      var k = window.bbCategory || {};
      Object.keys(a).forEach(function (code) {
        a[code].forEach(function (id) {
          m.aud[id] = code;
        });
      });
      Object.keys(k).forEach(function (c) {
        k[c].forEach(function (id) {
          m.cat[id] = c;
        });
      });
      return m;
    });
    return audMap;
  }

  function fetchSub(sub) {
    var url = root() + 'collections/' + sub + '?sort_by=best-selling&filter.v.availability=1&section_id=bombas-reco-pool';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.text();
      })
      .then(function (h) {
        var m = h.match(/data-bb-reco-pool>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : { items: [], pages: 1, origin: '' };
      });
  }

  var pools = {};
  function pool(sub) {
    var key = 'bbRecoBS:' + root() + ':' + sub;
    if (pools[key]) return pools[key];
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.at < TTL) return (pools[key] = Promise.resolve(c.data));
    } catch (e) {}
    pools[key] = fetchSub(sub).then(function (data) {
      try {
        sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data: data }));
      } catch (e) {}
      return data;
    });
    // A missing / failing sub-collection never blocks the others.
    pools[key] = pools[key].catch(function () {
      delete pools[key];
      return { items: [], origin: '' };
    });
    return pools[key];
  }

  function audOf(item, map) {
    if (item.a && CODES[item.a]) return CODES[item.a];
    if (map.aud[item.id]) return map.aud[item.id];
    return caAud(item.ca);
  }

  // Size system: 'n' shoes (numeric sizes), 'c' clothing (S / M / XL, 2A…).
  function sizeSys(v) {
    return /^\d+([.,]\d+)?$/.test(String(v || '').trim()) ? 'n' : 'c';
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  // Category words → the sub-collection of the source item when it isn't in a pool (French handle / type).
  var CAT_RX = [[/pyjama/, 'pyjama'], [/peignoir/, 'peignoir'], [/pantoufle|chausson|sabot/, 'pantoufles'],
    [/sandale|tong|claquette/, 'sandales'], [/botte|bottine|boots/, 'botte'], [/mocassin|ballerine|babies/, 'mocassins|chaussures-femme'],
    [/basket|sneaker|running/, 'sneakers|baskets']];
  function srcSub(subs, lists, src, map) {
    for (var i = 0; i < lists.length; i++) if (lists[i].some(function (it) { return String(it.id) === String(src.id); })) return i;
    var words = ((map.cat[src.id] || '') + ' ' + (src.type || '') + ' ' + (src.handle || '')).toLowerCase();
    for (var k = 0; k < CAT_RX.length; k++) {
      if (!CAT_RX[k][0].test(words)) continue;
      var rx = new RegExp(CAT_RX[k][1]);
      for (var j = 0; j < subs.length; j++) if (rx.test(subs[j])) return j;
    }
    return -1;
  }

  /* lists: one best-selling item list per sub-collection (same order as subs); src: { id, aud (code), size, type,
     exclude: {id: true} } → a varied, shuffled list (see 3–5 above). */
  function rank(subs, lists, map, src, max) {
    var ok = COMPAT[src.aud] || '';
    var useSize = !!src.size && (/^\d+([.,]\d+)?$/.test(src.size) || 'FGEB'.indexOf(src.aud) > -1);
    var srcSys = sizeSys(src.size);
    var seen = {};
    var cols = lists.map(function (items, si) {
      return items
        .filter(function (it) {
          var a = audOf(it, map);
          return !src.exclude[it.id] && a && ok.indexOf(a) > -1;
        })
        .map(function (it, pos) {
          var down = useSize && it.z && it.s.length && sizeSys(it.s[0]) === srcSys && it.s.indexOf(src.size) < 0;
          return { it: it, sub: si, pos: pos, tier: (down ? 2 : 0) + (it.g ? 0 : 1) };
        });
    });
    var rel = srcSub(subs, lists, src, map);
    var all = [].concat.apply([], cols);
    // newest 2 of each sub-collection (by creation date) join the discovery group
    var fresh = {};
    cols.forEach(function (c) {
      c.slice().sort(function (x, y) { return (y.it.c || 0) - (x.it.c || 0); }).slice(0, 2).forEach(function (x) { fresh[x.it.id] = true; });
    });
    var groups = {
      related: all.filter(function (x) { return x.sub === rel; }),
      best: all.filter(function (x) { return x.sub !== rel && x.pos < 6; }),
      discovery: all.filter(function (x) { return x.sub !== rel && (x.pos >= 6 || fresh[x.it.id]); })
    };
    // size first, good stock next, random inside
    var order = function (arr) {
      return shuffle(arr.slice()).sort(function (x, y) { return x.tier - y.tier; });
    };
    Object.keys(groups).forEach(function (k) { groups[k] = order(groups[k]); });
    var perSub = {};
    var out = [];
    var take = function (arr, n) {
      for (var i = 0; i < arr.length && n > 0 && out.length < max; i++) {
        var x = arr[i];
        if (seen[x.it.id] || (perSub[x.sub] || 0) >= PER_SUB) continue;
        seen[x.it.id] = true; perSub[x.sub] = (perSub[x.sub] || 0) + 1;
        out.push(x); n--;
      }
    };
    var third = Math.ceil(max / 3);
    // Cart drawer (owner, 30 Oct 2026): the first src.lead cards come from the added item's own sub-collection —
    // customer's size first, then the ones with the -100 DH price, then good stock — and stay first; the rest as before.
    var lead = [];
    if (src.lead && rel >= 0) {
      take(groups.related.slice().sort(function (x, y) {
        return (x.tier >= 2) - (y.tier >= 2) || (y.it.e ? 1 : 0) - (x.it.e ? 1 : 0) || x.tier - y.tier;
      }), src.lead);
      lead = out.splice(0);
      max -= lead.length;
    }
    take(groups.related, rel < 0 ? 0 : third - lead.length);
    take(groups.best, third);
    take(groups.discovery, max - out.length);
    // a group that ran short: fill from the others, then anything left in the audience
    take(groups.best, max - out.length);
    take(groups.related, max - out.length);
    if (lead.length + out.length < MIN) { PER_SUB = 99; take(order(all), MIN - lead.length - out.length); PER_SUB = 3; }
    // shuffled, but cards with the customer's size stay ahead of the ones without it
    return lead.concat(shuffle(out).sort(function (x, y) { return (x.tier >= 2) - (y.tier >= 2); })).map(function (x) { return x.it; });
  }

  function pick(src, max) {
    return audienceMap(src.audSrc).then(function (map) {
      if (!src.aud) src.aud = (src.id && map.aud[src.id]) || src.caAud || '';
      var subs = subsFor(src.aud);
      if (!subs.length) return { data: { origin: '' }, items: [] };
      return Promise.all(subs.map(pool)).then(function (datas) {
        var origin = '';
        datas.forEach(function (d) {
          origin = origin || d.origin || '';
        });
        return {
          data: { origin: origin },
          items: rank(
            subs,
            datas.map(function (d) {
              return d.items || [];
            }),
            map,
            src,
            max || MAX
          )
        };
      });
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cleanUrl(u) {
    return String(u || '').split('?')[0];
  }

  function cduCard(it, o) {
    var off = o.offer && it.e;
    var url = esc(cleanUrl(it.u));
    var h = '<div class="cdu-card"><a href="' + url + '" class="cdu-img">';
    if (it.i) h += '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" width="180" height="180" loading="lazy">';
    if (off) h += '<span class="cdu-badge">' + esc(o.badge) + '</span>';
    h += '</a><a href="' + url + '" class="cdu-name">' + esc(it.t) + '</a><div class="cdu-price">';
    h += off && it.pd ? '<s>' + esc(it.p) + '</s><span class="cdu-new">' + esc(it.pd) + '</span>' : esc(it.p);
    h += '</div>';
    if (off) h += '<div class="cdu-hint">' + esc(o.hint) + '</div>';
    if (it.d) {
      h += '<button type="button" class="cdu-add" data-cdu-add="' + it.d + '">' + esc(o.add) + '</button>';
    } else {
      h += '<div class="cdu-pick">' + esc(o.pick) + '</div><div class="cdu-sizes">';
      it.v.forEach(function (v) {
        h +=
          '<button type="button" class="cdu-size" data-cdu-add="' + v[0] + '" aria-label="' + esc(o.add + ' ' + it.t + ' – ' + v[1]) + '">' + esc(v[1]) + '</button>';
      });
      h += '</div>';
    }
    return h + '<div class="cdu-err" role="alert"></div></div>';
  }

  function vrCard(it, o, origin) {
    var url = cleanUrl(it.u).replace(/'/g, '%27');
    var h = '<div class="vr-card" data-pid="' + it.id + '" onclick="window.location.href=\'' + esc(url) + '\'"><div class="vr-card-img">' + (origin || '');
    if (it.i) h += '<img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" width="600" height="600" loading="lazy">';
    h += '</div><div class="vr-card-body"><div class="vr-card-name">' + esc(it.t) + '</div><div class="vr-card-prices"><span class="vr-card-price">' + esc(it.p) + '</span>';
    if (it.pc) h += '<span class="vr-card-old">' + esc(it.pc) + '</span>';
    h += '</div>';
    if (!it.d && it.vp.length) {
      h += '<div class="vr-card-sizes">';
      it.vp.forEach(function (v) {
        h += '<span class="vr-sz-pill' + (v[1] ? '' : ' out') + '">' + esc(v[0]) + '</span>';
      });
      h += '</div>';
    }
    return h + '<button type="button" class="vr-card-btn">' + esc(o.add) + '</button></div></div>';
  }

  // Audience from the product's collections (custom.audience), when nothing else is known.
  function caAud(ca) {
    var l = String(ca || '').split(' ').filter(Boolean);
    if (l.indexOf('enfants') > -1) return 'E';
    return l.length === 1 ? CODES[l[0]] || '' : '';
  }

  function ids(str) {
    var m = {};
    String(str || '')
      .split(',')
      .forEach(function (x) {
        if (x) m[x] = true;
      });
    return m;
  }

  /* Cart drawer: el = .cdu (data-* from cart-upsell.liquid). Resolves with the number of cards. */
  function fillCart(el) {
    var d = el.dataset;
    var src = { id: d.srcId, aud: CODES[d.aud] || '', caAud: caAud(d.ca), type: d.type || '', size: d.size || '', exclude: ids(d.incart), audSrc: d.audSrc, lead: 2 };
    // Phone: horizontal strip (up to 12); desktop: side panel (8).
    var max = window.matchMedia && window.matchMedia('(min-width: 750px)').matches ? 8 : MAX;
    return pick(src, max).then(function (r) {
      var list = el.querySelector('.cdu-list');
      if (!list) return 0;
      var o = { offer: d.offer === 'true', badge: d.badge, hint: d.hint, add: d.add, pick: d.pick };
      list.innerHTML = r.items.map(function (it) {
        return cduCard(it, o);
      }).join('');
      return r.items.length;
    });
  }

  /* Product page: el = [data-bb-reco="vr"] (sections/related-products.liquid). */
  function currentSize(el) {
    var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var vid = (form && form.value) || new URLSearchParams(location.search).get('variant') || '';
    var map = {};
    try {
      map = JSON.parse(el.getAttribute('data-variant-sizes') || '{}');
    } catch (e) {}
    return (vid && map[vid]) || el.getAttribute('data-size') || '';
  }

  function fillProduct(el) {
    var d = el.dataset;
    var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    var size = currentSize(el);
    if (el.__bbSize === size && el.__bbDone) return Promise.resolve();
    el.__bbSize = size;
    return fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return { items: [] };
      })
      .then(function (cart) {
        var ex = {};
        ex[d.pid] = true;
        (cart.items || []).forEach(function (i) {
          ex[i.product_id] = true;
        });
        var src = { id: d.pid, aud: CODES[d.aud] || '', caAud: caAud(d.ca), type: d.type || '', size: size, exclude: ex, audSrc: d.audSrc };
        return pick(src);
      })
      .then(function (r) {
        var track = el.querySelector('.vr-track');
        if (!r.items.length) {
          el.closest('.bb-reco-wrap').hidden = true;
          return;
        }
        track.style.transform = '';
        window.vrIndex = 0;
        track.innerHTML = r.items.map(function (it) {
          return vrCard(it, { add: d.add }, r.data.origin);
        }).join('');
        el.classList.add('is-ready');
        el.__bbDone = true;
      });
  }

  function initProduct() {
    var el = document.querySelector('[data-bb-reco="vr"]');
    if (!el) return;
    var go = function () {
      fillProduct(el).catch(function (e) {
        console.error('[reco]', e);
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) {
            io.disconnect();
            go();
          }
        },
        { rootMargin: '900px 0px' }
      );
      io.observe(el);
    } else {
      go();
    }
    // Size chosen on the product page → products with that size in stock first.
    document.addEventListener('change', function (e) {
      if (el.__bbDone && e.target.closest && e.target.closest('form[action*="/cart/add"], .product-form, [id^="product-form"]')) setTimeout(go, 50);
    });
    document.addEventListener('click', function (e) {
      if (!el.__bbDone || !e.target.closest) return;
      if (e.target.closest('main') && !e.target.closest('[data-bb-reco]')) setTimeout(go, 120);
    });
  }

  window.BBReco = { fillCart: fillCart, fillProduct: fillProduct, rank: rank };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProduct);
  else initProduct();
})();
